import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-footer7 thq-section-padding">
      <div className="footer-max-width thq-section-max-width">
        <div className="footer-content">
          <div className="footer-logo"></div>
          <div className="footer-links">
            <a href="/" className="thq-body-small">
              <Fragment>
                <span className="footer-text16">Home</span>
              </Fragment>
            </a>
            <a href="/about" className="thq-body-small">
              <Fragment>
                <span className="footer-text18">About</span>
              </Fragment>
            </a>
            <a href="/estimator" className="thq-body-small">
              <Fragment>
                <span className="footer-text15">Calculator</span>
              </Fragment>
            </a>
            <a href="/faq" className="thq-body-small">
              <Fragment>
                <span className="footer-text19">FAQ</span>
              </Fragment>
            </a>
            <a
              href="mailto:support@coinbasis.tech"
              className="thq-body-small"
            >
              <Fragment>
                <span className="footer-text14">Contact</span>
              </Fragment>
            </a>
            <a href="https://x.com/CoinBasisLLC" className="thq-body-small">
              <Fragment>
                <span className="footer-text17">Twitter</span>
              </Fragment>
            </a>
          </div>
        </div>
        <div className="footer-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer-row">
            <div className="footer-container">
              <span className="thq-body-small">© 2025 Coin Basis LLC</span>
            </div>
            <div className="footer-footer-links">
              <Link
                to="/faq#Terms-and-Privacy"
                className="footer-text11 thq-body-small"
              >
                <Fragment>
                  <span className="footer-text21">Privacy Policy</span>
                </Fragment>
              </Link>
              <Link to="/faq#Terms-and-Privacy" className="thq-body-small">
                <Fragment>
                  <span className="footer-text17">Terms of Service</span>
                </Fragment>
              </Link>
              <Link to="/faq#Terms-and-Privacy" className="thq-body-small">
                <Fragment>
                  <span className="footer-text20">Cookies Policy</span>
                </Fragment>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
